import React from "react";
import "./work.scss";

export default function Work() {
  const data = [
    {
      id: 1,
      name: "Rock,Paper & Scissor",
      title: "HTML/CSS/Javascript",
      img: "/assets/rps.png",
    },
    {
      id: 2,
      name: "Image-Gallery",
      title: "React/Tailwind",
      img: "/assets/images.jpg",
      
    },
    {
      id: 3,
      name: "Mobile-Store",
      title: "React/Redux/Bootstrap",
      img: "/assets/mobileStore1.PNG",
    }
   ,{
      id: 5,
      name: "Todays-plan",
      title: "React/Router/Bootstrap",
      img: "/assets/todayPlan.jpg",
    },{
      id: 6,
      name: "Tour2uk",
      title:"React/CSS/Firebase",
      img: "/assets/tour2uk.jpg",
    },
  ];
  return (
    <div className="work" id="work">
      <h1 className='heading'>My Projects</h1>
      <div className="container">
        {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"}>
            <div className="top">
              <img className="user" src={d.img} alt="" />
            </div>

            <div className="bottom">
              <h3>{d.name}</h3>
              <h4>{d.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
